import { ISolicitationEntry } from '../../../../contentful/types/ISolicitationEntry';

export enum SolicitationsFilterOptions {
	Type = 'type',
	Category = 'category',
	Location = 'location',
	Status = 'status',
}

export const SOLICITATIONS_ALL_TYPES = 'All Types';
export const SOLICITATIONS_ALL_CATEGORIES = 'All Categories';
export const SOLICITATIONS_ALL_LOCATIONS = 'All Locations';
export const SOLICITATIONS_ALL_STATUSES = 'All Statuses';

export const solicitationsFilterOptions = Object.values(
	SolicitationsFilterOptions,
);

export const mapSolicitationFilterTypeToFilterItems = (
	filterType: SolicitationsFilterOptions,
	solicitations: ISolicitationEntry[],
) => {
	const getUniqueValues = (
		extractor: (
			solicitation: ISolicitationEntry,
		) => string | string[] | undefined,
	) =>
		Array.from(
			new Set(solicitations.flatMap(extractor).filter(Boolean)),
		) as string[];

	const map = {
		[SolicitationsFilterOptions.Type]: [
			SOLICITATIONS_ALL_TYPES,
			...getUniqueValues((s) => s.fields.type),
		],
		[SolicitationsFilterOptions.Category]: [
			SOLICITATIONS_ALL_CATEGORIES,
			...getUniqueValues((s) => s.fields.category),
		],
		[SolicitationsFilterOptions.Location]: [
			SOLICITATIONS_ALL_LOCATIONS,
			...getUniqueValues((s) => s.fields.location),
		],
		[SolicitationsFilterOptions.Status]: [
			SOLICITATIONS_ALL_STATUSES,
			...getUniqueValues((s) => s.fields.status),
		],
	};

	return map[filterType];
};
